
































import { Component, Vue, Prop, Emit } from "vue-property-decorator"
import { DialogSize } from '@/configs/fileTypes'

@Component
export default class FormDialog extends Vue {
  public name: string = "FormDialog"
  @Prop({ default: '' })
  public cssClass: string = ''
  //max、medium、small、mini
  @Prop({ default: '' })
  public size: DialogSize = 'max'
  //:width=""
  @Prop({ default: '' })
  public width: string = ''
  //:title=""
  @Prop({ default: '' })
  public title: string = ''
  //:visible=""
  @Prop({ default: false })
  public visible: boolean = false
  //:close="function"
  @Prop({ default: null })
  public close!: () => void
  @Prop({ default: null })
  //:submit="function"
  public submit!: () => void
  public get getClass(): string {
    var className = 'dialog-form'
    var c = this.cssClass
    if (c != '') {
      className += ' ' + c
    }
    return className
  }
  public get getWidth(): string {
    var w = this.width
    var s = this.size
    if (w == '') {
      //内容溢出的页面，文保单位及其内部模块
      if (s == 'max') {
        w = '80%'
      }
      //内容较为丰富的页面，首页地图展示，巡查轨迹
      else if (s == 'medium') {
        w = '66%'
      }
      //简单内容的页面，查询列表，图纸维护，坐标点维护等
      else if (s == 'small') {
        w = '50%'
      }
      else {
        //单列展示的内容，基础数据上下级维护，文件上传等
        w = '33%'
      }
    }
    return w
  }
  public created() { }
}
